function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { MagicFormBrick, MagicInputColorBrick, MagicInputFaIconBrick, MagicInputRadioBrick, MagicInputSelectorBrick, MagicInputTextBrick, FormBuilder } from "zengular-magic";
import article from "../../../../Andesite/Ghost/descriptors/article";
import GmarkEditorBrick from "../inputs/gmark-editor/gmark-editor.brick";

var ArticleFormBrick = /*#__PURE__*/function (_MagicFormBrick) {
  _inherits(ArticleFormBrick, _MagicFormBrick);

  var _super = _createSuper(ArticleFormBrick);

  function ArticleFormBrick() {
    _classCallCheck(this, ArticleFormBrick);

    return _super.apply(this, arguments);
  }

  _createClass(ArticleFormBrick, [{
    key: "formBuilder",
    get: function get() {
      var formBuilder = new FormBuilder();
      var section;
      section = formBuilder.add();
      section.add(article.fields.title);
      section.add(article.fields.lead, MagicInputTextBrick);

      if (this.type !== ArticleFormBrick.type.forum) {
        section.add(article.fields.body, MagicInputTextBrick, MagicInputTextBrick.setAttributes(GmarkEditorBrick));
      }

      section = formBuilder.add('Adatok');
      section.add.inline(article.fields.authorId, MagicInputSelectorBrick, MagicInputSelectorBrick.setAttributes('/api/users'));
      section.add.inline(article.fields.publishDate);
      section.add.inline(article.fields.status);
      section.add.inline(article.fields.comment_status, MagicInputRadioBrick);

      if (this.type === ArticleFormBrick.type.blog) {
        section.add.inline(article.fields.feed);
      }

      if (this.type === ArticleFormBrick.type.forum) {
        section.add.inline(article.fields.label, MagicInputRadioBrick, MagicInputRadioBrick.setAttributes(['OffTopic', 'GamingTopic']));
        section.add.inline(article.fields.iconColor, MagicInputColorBrick);
        section.add.inline(article.fields.icon, MagicInputFaIconBrick).setHint("Ikonokat itt kereshetsz <a href=\"https://fontawesome.com/icons?d=gallery\" target=\"_blank\">Fontawesome</a>");
      }

      section.add.inline(article.fields.permalink);
      section.add.inline(article.fields.metaKeywords);
      section.add.inline(article.fields.metaDescription);
      return formBuilder;
    }
  }]);

  return ArticleFormBrick;
}(MagicFormBrick);

_defineProperty(ArticleFormBrick, "type", {
  blog: "blog",
  forum: "forum",
  article: "article",
  news: "news",
  podcast: "podcast",
  document: "document"
});

_defineProperty(ArticleFormBrick, "dictionary", {
  "input": {
    "title": "cím",
    "lead": "lead",
    "markup": "markup",
    "body": "szöveg",
    "label": "típus",
    "comment_status": "kommentek",
    "status": "státusz",
    "feed": "feed",
    "iconcolor": "ikon szín",
    "icon": "ikon",
    "publishdate": "megjelenés",
    "authorid": "szerző",
    "metakeywords": "meta keywords",
    "metadescription": "meta description"
  },
  "option": {
    "label": {
      "blog": "Blog",
      "ad": "Ad",
      "gamingtopic": "GamingTopic",
      "offtopic": "OffTopic",
      "news": "News",
      "article": "Article",
      "podcast": "Podcast",
      "document": "Document"
    },
    "comment_status": {
      "open": "nyitott",
      "closed": "lezárt",
      "hidden": "rejtett"
    }
  },
  "order": {
    "id": "id",
    "publishdate": "megjelenés"
  },
  "card": {
    "property": {
      "publishdate": "megjelenés"
    }
  }
});

export { ArticleFormBrick as default };